export enum RotationStatus {
    InProgress = 'InProgress',
    Succeeded = 'Succeeded',
    Failed = 'Failed'
}
